import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Avatar from '@material-ui/core/Avatar';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import ListItemText from '@material-ui/core/ListItemText';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import Dialog from '@material-ui/core/Dialog';
import PersonIcon from '@material-ui/icons/Person';
import AddIcon from '@material-ui/icons/Add';
import Typography from '@material-ui/core/Typography';
import blue from '@material-ui/core/colors/blue';
import { connect } from 'react-redux';
import { withRouter, Redirect } from 'react-router-dom';
import CaseItemLinkList from '../../components/CaseItemLinkList';
import axios from 'axios';
import PrimaryAppBar from '../../components/PrimaryAppBar';

const styles = {
  dialog: {
  },
};

class CasesDialog extends React.Component {
  state = {
    caseItems: [],
  }

  componentDidMount(){
    console.log('CasesDialog reached')
      let url = `${process.env.REACT_APP_SERVER_HOSTNAME}:${process.env.REACT_APP_SERVER_PORT}/getUserCases`;
      let payload = {
        uniqueId: localStorage.getItem('token'),
      }
      axios.post(url, payload)
      .then((response) => {
          if(response.data === 'error' || response.data === 'failed'){
              throw (`login ${response.data}`);
          }
          console.log('List of cases: '+JSON.stringify(response.data));
          if (response.data == 'no_cases' || response.data == 'error'){
            
          }
          else {
            this.setState({caseItems: response.data});
          }
      })
      .catch((error) => {
          console.log(error);
      });
      // console.log('this.state.caseItems: '+this.state.caseItems)
  }

  render() {
    if(!this.props.isAuthenticated){
      return(<Redirect to='/' />)
    }
    return (
      <div>
        <PrimaryAppBar />
        <CaseItemLinkList caseItems={this.state.caseItems} context = {this.context}/>
      </div>
    );
  }
}


const mapStateToProps = (state) => {
  return {
    isAuthenticated: state.auth.token !== null,
    //firstTimeSignIn: state.auth.newAccount,
  };
}

const mapDispatchToProps = (dispatch) => {
  return {
    //onTryAutoSignIn: (newAccount) => dispatch(actions.checkAuthState(newAccount)),
  };
}
CasesDialog.contextTypes = {
  t: PropTypes.func
}
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(CasesDialog));